import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Paper, TextField } from '@mui/material';
import api from '../../../api/api'
import Loading from '../../../components/loading';
import SuccessMessage from '../../../components/successMessage';
import ErrorMessage from '../../../components/errorMessage';

export default function AnamnesisForm() {

    const navigate = useNavigate();

    const { patientId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [perguntasComResposta, setPerguntasComResposta] = useState([]);
    const [queixaPrincipal, setQueixaPrincipal] = useState('');
    const [anamneseId, setAnamneseId] = useState(0);

    const obterAnamneseDoPaciente = useCallback((patientId) => {
        if (!patientId) {
            return;
        }
        api.get("/anamnese/paciente/".concat(patientId), {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((resposta) => {
            if (resposta.data) {
                setAnamneseId(resposta.data.id);
                setQueixaPrincipal(resposta.data.queixaPrincipal);
                resposta.data.perguntasComRespostasDaAnamnese.forEach((pergunta) => {
                    if (!pergunta.observacao) {
                        pergunta.observacao = '';
                    }
                });
                setPerguntasComResposta(resposta.data.perguntasComRespostasDaAnamnese);
            } else {
                obterPerguntasComRespostas();
            }
        }).catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }        
        });
    }, [navigate]);

    useEffect(() => {
        obterAnamneseDoPaciente(patientId);
    }, [patientId, obterAnamneseDoPaciente]);

    function obterPerguntasComRespostas() {
        api.get("/anamnese/perguntas", {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((resposta) => {
            setPerguntasComResposta(resposta.data);
        }).catch((err) => {
            console.error("ops! ocorreu um erro" + err);
        });
    }

    const saveAnamnesis = (event) => {
        event.preventDefault();

        const anamnese = {
            "id": anamneseId,
            "queixaPrincipal": queixaPrincipal,
            "perguntasComRespostasDaAnamnese": perguntasComResposta,
            "pacienteId": patientId
        }

        setLoading(true);

        if (anamneseId) {
            api.put("/anamnese", anamnese, {
                headers: {
                    Authorization: sessionStorage.getItem('token')
                }
            }).then((returnFromApi) => {
                setLoading(false);
                setShowSuccessMessage(true);
                setSuccessMessage(returnFromApi.data)
            }).catch((returnFromApi) => {
                console.error(returnFromApi);
                setLoading(false);
                setShowErrorMessage(true);
                setErrorMessage(returnFromApi.response.data);
            });
        } else {
            api.post("/anamnese", anamnese, {
                headers: {
                    Authorization: sessionStorage.getItem('token')
                }
            }).then((returnFromApi) => {
                setLoading(false);
                setShowSuccessMessage(true);
                setSuccessMessage(returnFromApi.data);
            }).catch((returnFromApi) => {
                setLoading(false);
                setShowErrorMessage(true);
                setErrorMessage(returnFromApi.response.data);
                console.error(returnFromApi);
            });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function atualizarObservacao(value, perguntaComResposta) {
        const listaDePerguntasAtualizadas = [];
        perguntasComResposta.forEach((pergunta) => {
            if (pergunta.id === perguntaComResposta.id) {
                pergunta.observacao = value;
                listaDePerguntasAtualizadas.push(pergunta);
            } else {
                listaDePerguntasAtualizadas.push(pergunta);
            }
        });
        setPerguntasComResposta(listaDePerguntasAtualizadas);
    }

    return (
        <Box component="form" onSubmit={saveAnamnesis}>

            <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}


            <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                <TextField
                    fullWidth
                    label="Queixa Principal"
                    value={queixaPrincipal}
                    onChange={(e) => setQueixaPrincipal(e.target.value)}
                    variant="outlined"
                    multiline
                    rows={3}
                />
            </Paper>

            <Box
                sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {perguntasComResposta.map((perguntaComResposta) => (
                    <Box key={perguntaComResposta.id} sx={{ width: { xs: '100%', sm: '50%' }, p: 1, }}>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                            <TextField
                                fullWidth
                                label={perguntaComResposta.pergunta}
                                value={perguntaComResposta.observacao}
                                onChange={e => atualizarObservacao(e.target.value, perguntaComResposta)}
                                variant="outlined"
                                multiline
                                rows={2}
                            />
                        </Paper>
                    </Box>
                ))}
            </Box>
            <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="submit" variant="contained">
                    Salvar
                </Button>
            </Box>
        </Box>
    );
}